import React, { useEffect, useState } from 'react';

import { Drawer, Form, Button, Table, DatePicker, Tag, InputNumber, Input } from 'antd';
import errorMessage from 'global_config/error_messages';
import { AlphaNumInput, RegexInput, NumberInput } from 'shared_components/pattern_input';
import {
	QualityControlChart,
	addQualityControlGenerateReport,
	fetchGenerateView,
	fetchGeneratedReportsList,
	qualityControlChartPrint,
} from 'services/settings/qualityControl';
import moment from 'moment';
import GenerateView from './generateView';
import HttpCodeMessage from 'shared_components/message_http_status';
import Message from 'shared_components/message';

const GenerationForm = ({ visible, onClose, record }) => {
	const [form] = Form.useForm();

	const [PDFdata, setPDFdata] = useState(null);
	const [paramValues, setParamValues] = useState(null);
	const [FormValues, setFormValues] = useState(null);
	const [isShowGenerateView, setIsShowGenerationView] = useState(false);
	const [action, setAction] = useState(null);
	const [generatedReportsList, setGeneratedReportsList] = useState(null);
	const [isLoading, setIsloading] = useState(false);

	const columns = [
		{
			title: 'DESCRIPTION',
			dataIndex: 'description',
			width: 450,
			text: 'center',
		},
		{
			title: 'START DATE',
			dataIndex: 'mstartdate',
			width: 150,
		},
		{
			title: 'N0. OF DAYS',
			dataIndex: 'mdaycount',
			width: 100,
		},
		{
			title: 'DATE GENERATED',
			dataIndex: 'timecreated',
			width: 200,
		},
		{
			title: 'MED TECH',
			dataIndex: 'generatedby',
			width: 100,
		},
		{
			title: 'STATUS',
			dataIndex: 'reportstatus',
			render: status => (
				<Tag color={status === 0 ? 'red' : 'green'}>{status === 0 ? 'INACTIVE' : 'ACTIVE'}</Tag>
			),
			width: 100,
		},
		{
			title: 'ACTION',
			dataIndex: '',
			width: 150,
			render: record => (
				<div
					style={{ display: 'flex', gap: '10px', alignItems: 'center' }}
					className="font-md leading-none"
				>
					<p className="hover leading-botton-0" onClick={() => handleGenerateView(record)}>
						VIEW
					</p>
					|
					<p className="hover leading-botton-0" onClick={() => handleGeneratePrint(record)}>
						PRIN T
					</p>
				</div>
			),
		},
	];

	useEffect(() => {
		fetchData();
	}, [record]);

	const fetchData = async () => {
		if (record) {
			const payload = {
				mlotno: record ? record.lotno : null,
				manalyteid: record ? record.analyteid : null,
			};

			try {
				const generatedReportsListData = await fetchGeneratedReportsList(payload);
				// Process the data or update the state
				// @ts-ignore
				const generatedReportsList = generatedReportsListData.data.records.map(item => {
					const data = item.querystring[0];
					const startDateAndNoOfDays = getStartDateAndDaysBetween(item.description);
					const timeCreated = moment(item.timecreated).format('MM-DD-YYYY');
					const generatedReports = {
						...item,
						...data,
						timeCreated,
						mdaycount: startDateAndNoOfDays.totaldays,
						mstartdate: startDateAndNoOfDays.startdate,
					};
					return generatedReports;
				});
				setGeneratedReportsList(generatedReportsList);
				console.log(generatedReportsList);
			} catch (error) {
				setGeneratedReportsList(null);
			}
		}

		console.log(record);
	};

	const getStartDateAndDaysBetween = description => {
		// Regular expression to extract the two dates from the description
		const dateRegex = /\((.*)\s-\s(.*)\)/;
		const matches = description.match(dateRegex);

		if (matches && matches.length === 3) {
			// Convert the two extracted date strings into Date objects
			const startDate = new Date(matches[1]);
			const endDate = new Date(matches[2]);

			// Calculate the difference in time (in milliseconds)
			// @ts-ignore
			const diffTime = Math.abs(endDate - startDate);

			// Convert the difference from milliseconds to days
			const totalDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

			// Format the start date using moment
			const formattedStartDate = moment(startDate).format('MM-DD-YYYY');

			// Return the start date and total days
			return {
				startdate: formattedStartDate,
				totaldays: totalDays,
			};
		}

		return null;
	};

	const onSubmit = async value => {
		if (value) {
			const startdate = value.mstartdate.format('YYYY-MM-DD');
			const querystring = [
				{
					mstartdate: startdate,
					manalyteid: record.analyteid.toString(),
					mdaycount: value.mdaycount.toString(),
				},
			];

			const payload = {
				mode: 'export',
				parameters: querystring,
			};

			setIsloading(true);

			try {
				const response = await QualityControlChart(JSON.stringify(payload));

				// @ts-ignore
				if (response.status === 200) {
					const httpMessageConfig = {
						// @ts-ignore
						message: response.data.message,
						// @ts-ignore
						status: response.status,
						duration: 3,
					};
					HttpCodeMessage(httpMessageConfig);

					// Process the data or update the state
					// @ts-ignore
					setParamValues(response.data.records[0].paramvalues[0]);
					setFormValues({ mstartdate: startdate, mdaycount: value.mdaycount });
					// @ts-ignore
					setPDFdata(response.data.records[0].pdf);
					setIsShowGenerationView(true);
					setAction('add');
					form.resetFields(); // Clear form fields
				}
				setIsloading(false);

				console.log('response', response);
			} catch (error) {
				console.log('Error generateView:', error);
				// Handle the error gracefully
			}
		}
	};

	const handleAddQualityControlGenerateReport = async () => {
		if (paramValues && record) {
			const LOGGEDIN_USER_DATA = sessionStorage.LOGGEDIN_USER_DATA
				? JSON.parse(sessionStorage.LOGGEDIN_USER_DATA)
				: null;
			const { givenName, middleName, lastName, userID } = LOGGEDIN_USER_DATA;

			console.log(LOGGEDIN_USER_DATA);

			//formated payload
			const fullname = `${givenName} ${middleName} ${lastName}`;

			const CustomStartDate = moment(FormValues.mstartdate)
				.format('MMMM D, YYYY')
				.toUpperCase();
			const CustomEndDate = moment(FormValues.mstartdate)
				.add(FormValues.mdaycount, 'days')
				.format('MMMM D, YYYY')
				.toUpperCase();
			const description = `${record.examname}-${record.levelname} (${CustomStartDate} - ${CustomEndDate})`;

			console.log(paramValues);

			const payload = {
				mlotno: Number(record.lotno),
				manalyteid: record.analyteid,
				mgeneratedby: userID,
				mfilename: JSON.stringify([paramValues]),
				mdescription: description,
			};

			console.log(payload);

			try {
				const response = await addQualityControlGenerateReport(JSON.stringify(payload));
				console.log(response);
				// @ts-ignore
				if (response.status === 200) {
					const httpMessageConfig = {
						// @ts-ignore
						message: response.data.message,
						// @ts-ignore
						status: response.status,
						duration: 3,
					};
					HttpCodeMessage(httpMessageConfig);
					setIsShowGenerationView(false);
					fetchData();
				}
			} catch (error) {
				console.log('Error add QualityControlGenerateReport:', error);
				// Handle the error gracefully
			}
		}
	};

	const handleGenerateView = async record => {
		console.log(record);

		if (record) {
			const fullFilename = record.querystring[0].filename;
			const filenameWithoutExtension = fullFilename.replace(/\.[^/.]+$/, ''); // Remove file extension

			const payload = {
				filename: filenameWithoutExtension, // Use the filename without the extension
				filetype: record.querystring[0].filetype,
			};

			console.log('payload ,', payload);

			try {
				const response = await fetchGenerateView(payload);
				// Process the data or update the state
				console.log('image', response);

				// @ts-ignore
				if (response.status === 200) {
					const httpMessageConfig = {
						// @ts-ignore
						message: response.data.message,
						// @ts-ignore
						status: response.status,
						duration: 3,
					};
					HttpCodeMessage(httpMessageConfig);
					// @ts-ignore
					setParamValues(response.paramvalues);
					// @ts-ignore
					setPDFdata(response.data.records[0].pdf);
					setIsShowGenerationView(true);
					setAction(null);
				}
			} catch (error) {
				console.log('Error generateView:', error);
				// Handle the error gracefully
			}
		}
	};

	const handleGeneratePrint = async record => {
		console.log(record);

		if (record) {
			const fullFilename = record.querystring[0].filename;
			const filenameWithoutExtension = fullFilename.replace(/\.[^/.]+$/, ''); // Remove file extension

			const payload = [
				{
					filename: filenameWithoutExtension, // Use the filename without the extension
					filetype: record.querystring[0].filetype,
				},
			];

			console.log('payload ,', payload);
			try {
				const response = await qualityControlChartPrint(payload);
				// Process the data or update the state
				console.log('image', response);

				// @ts-ignore
				if (response.status === 200) {
					const httpMessageConfig = {
						// @ts-ignore
						message: response.data.message,
						// @ts-ignore
						status: response.status,
						duration: 3,
					};
					HttpCodeMessage(httpMessageConfig);
					onClose(false);
				}
			} catch (error) {
				console.log('Error generateView:', error);
				// Handle the error gracefully
			}
		}
	};

	const fieldRules = {
		required: [{ required: true, message: errorMessage.required }],
		numeric: [{ required: true, message: errorMessage.number }],
	};

	return (
		<Drawer
			title={`LOT NO. ${record ? record.lotno : null} | ${record ? record.sectionname : null} | ${
				record ? record.examname : null
			} |  ${record ? record.levelname : null} | ${record ? record.level : null}`}
			width="80%"
			placement="right"
			closable
			onClose={() => onClose(false)}
			visible={visible}
		>
			<Form
				form={form}
				onFinish={onSubmit}
				className="quality-control-data-container"
				layout="vertical"
			>
				<div className="form">
					<Form.Item
						name="mstartdate"
						label="DATE"
						style={{ width: '25%' }}
						rules={fieldRules.required}
					>
						<DatePicker format="YYYY-MM-DD" style={{ width: '100%' }} />
					</Form.Item>
					<Form.Item
						name="mdaycount"
						label="NO. OF DAYS"
						style={{ width: '25%' }}
						rules={fieldRules.required}
					>
						<Input type="number" />
					</Form.Item>
					<Button
						shape="round"
						htmlType="submit"
						type="primary"
						loading={isLoading}
						style={{ marginTop: '5px', width: 120 }}
					>
						GENERATE
					</Button>
				</div>

				<Table
					style={{ marginTop: '10px' }}
					// @ts-ignore
					pagination={true}
					columns={columns}
					dataSource={generatedReportsList}
				/>

				<section className="drawerFooter">
					<div>
						<Button shape="round" style={{ margin: 10, width: 120 }} onClick={() => onClose(false)}>
							CLOSE
						</Button>
					</div>
				</section>
			</Form>

			<GenerateView
				visible={isShowGenerateView}
				onClose={setIsShowGenerationView}
				PDFdata={PDFdata}
				action={action}
				onSave={handleAddQualityControlGenerateReport}
			/>
		</Drawer>
	);
};

export default GenerationForm;
